import { BaseBadge } from './BaseBadge';
import { BaseToolBadgeProps } from './types';

interface DefaultBadgeProps extends BaseToolBadgeProps {
  toolName: string;
}

export const DefaultBadge = ({ toolName, ...props }: DefaultBadgeProps) => {
  return (
    <BaseBadge
      {...props}
      resultTexts={{
        loading: `Using tool: ${toolName}...`,
        done: `Used tool: ${toolName}`,
        error: `Error using tool: ${toolName}`,
      }}
    />
  );
};
